/******************************************************************************
 *
 * WorkDocumentsCard
 *
 * Work Execution Documents
 *
 * Future
 *
 * • Upload
 * • Camera
 * • Gallery
 * • Voice Notes
 * • Version History
 * • Download
 * • Preview
 *
 ******************************************************************************/

import React from "react";

export default function WorkDocumentsCard({

    documents = [],

    onUpload,

    onPreview,

    onDownload,

    onDelete

}) {

    function getIcon(type) {

        switch (type) {

            case "PDF":
                return "📕";

            case "IMAGE":
                return "🖼️";

            case "VIDEO":
                return "🎥";

            case "EXCEL":
                return "📊";

            case "WORD":
                return "📄";

            default:
                return "📁";

        }

    }

    return (

        <div className="card border-0 shadow-sm h-100">

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        📂 Documents

                    </h5>

                    <button
                        className="btn btn-primary btn-sm"
                        onClick={onUpload}
                    >

                        Upload

                    </button>

                </div>

            </div>

            <div
                className="card-body"
                style={{
                    maxHeight: 450,
                    overflowY: "auto"
                }}
            >

                {

                    documents.length === 0

                    ?

                    <div className="text-center py-5 text-muted">

                        No Documents Uploaded

                    </div>

                    :

                    documents.map(doc => (

                        <div
                            key={doc.id}
                            className="border rounded p-3 mb-3"
                        >

                            <div className="d-flex justify-content-between">

                                <div>

                                    <div className="fw-semibold">

                                        {getIcon(doc.file_type)}

                                        {" "}

                                        {doc.file_name}

                                    </div>

                                    <small className="text-muted">

                                        Uploaded By

                                        {" "}

                                        {doc.uploaded_by}

                                    </small>

                                    <br />

                                    <small className="text-muted">

                                        {doc.uploaded_at}

                                    </small>

                                </div>

                                <div>

                                    <button
                                        className="btn btn-sm btn-outline-primary me-2"
                                        onClick={() => onPreview(doc)}
                                    >

                                        Preview

                                    </button>

                                    <button
                                        className="btn btn-sm btn-outline-success me-2"
                                        onClick={() => onDownload(doc)}
                                    >

                                        Download

                                    </button>

                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => onDelete(doc)}
                                    >

                                        Delete

                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}